module.exports = __webpack_public_path__ + "media/images/rate-average-2f332436.png";